(() => {
  if (window.__glBlogIndexBound) return;
  window.__glBlogIndexBound = true;

  const showLabel = 'Show remaining tags';
  const hideLabel = 'Hide remaining tags';

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-gl-tags-toggle]');
    if (!button) return;

    const list = button.closest('[data-gl-tags]');
    if (!list) return;

    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', open ? 'true' : 'false');

    const hiddenLabel = button.querySelector('.visually-hidden');
    if (hiddenLabel) hiddenLabel.textContent = open ? hideLabel : showLabel;

    list.querySelectorAll('[data-gl-tag-extra]').forEach((item) => {
      item.hidden = !open;
    });
  });
})();
